import React from "react";
import "./app.css";

import { Article, Brand, Cta, Feature, Navbar } from "./components";
import Todos from "./components/todos/Todos";
import {
  Blog,
  Features,
  Footer,
  Header,
  Possibility,
  Whatis,
} from "./containers";

const App = () => {
  return (
    <div>
      <div className="App">
        {/* <Todos /> */}
        <div className="gradient__bg">
          <Navbar />
          <Header />
        </div>
        <Brand />
        <Whatis />
        <Features />
        <Possibility />
        <Blog />
        <Footer />
      </div>
    </div>
  );
};

export default App;
